import { render, staticRenderFns } from "./MasterData.vue?vue&type=template&id=0c71e672&"
import script from "./MasterData.vue?vue&type=script&lang=ts&"
export * from "./MasterData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports